import { Overlay, OverlayConfig, OverlayRef, PositionStrategy } from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { Injectable, Injector } from '@angular/core';
// tslint:disable-next-line: ordered-imports
import {
  ToasterMessageData,
  ToasterMessageType,
  TOASTER_AUTOCLOSE_FLAG, TOASTER_CONTAINER_DATA
} from './pseic-toaster-ref';
import { PseicToasterComponent } from './pseic-toaster/pseic-toaster.component';

@Injectable({
  providedIn: 'root'
})
export class PseicToasterService {

  constructor(
    private overlay: Overlay,
    public _injector: Injector
  ) {
  }

  // Send message to toaster stream
  open(message: string, messageType: ToasterMessageType = 'message', autoClose: boolean = true): OverlayRef {
    const overlayRef = this.overlay.create(new OverlayConfig({
      positionStrategy: this.getOverlayPosition()
    }));
    const componentPortal = new ComponentPortal(
      PseicToasterComponent,
      null,
      this.createInjector({
        message,
        messageType,
        overlayRef,
        autoClose
      })
    );
    overlayRef.attach(componentPortal);
    return overlayRef;
  }

  private createInjector(dataToPass: ToasterMessageData): PortalInjector {
    const injectorTokens = new WeakMap();
    injectorTokens.set(TOASTER_CONTAINER_DATA, dataToPass);
    injectorTokens.set(TOASTER_AUTOCLOSE_FLAG, dataToPass.autoClose);
    return new PortalInjector(this._injector, injectorTokens);
  }

  private getOverlayPosition(): PositionStrategy {
    const positionStrategy = this.overlay.position()
      .global()
      .left('24px')
      .bottom('24px')

    return positionStrategy;
  }
}
